import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPinIcon, CheckCircleIcon } from 'lucide-react';
const names = ['Alejandro', 'María', 'Diego', 'Sofía', 'Fernando', 'Camila', 'Gustavo', 'Lucía', 'Pablo', 'Daniela', 'Marcos', 'Florencia', 'Nicolás', 'Andrea', 'Sebastián'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      // Pick random name and city
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialDelay = setTimeout(showPopup, 3000);
    // Then show randomly every 8-12 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 4000) + 8000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-146">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white border border-gray-200 shadow-xl rounded-lg p-4 flex items-start gap-3" data-id="element-147">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-148">
            <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-149" />
          </div>
          <div data-id="element-150">
            <p className="text-sm text-gray-800 font-medium" data-id="element-151">
              <span className="font-bold" data-id="element-152">{currentName}</span> acaba de comprar
              este pack
            </p>
            <div className="flex items-center gap-1 mt-1 text-xs text-gray-500" data-id="element-153">
              <MapPinIcon className="w-3 h-3" data-id="element-154" />
              <span data-id="element-155">{currentCity}, Argentina</span>
            </div>
            <p className="text-xs text-green-600 font-semibold mt-1" data-id="element-156">
              Hace unos minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}